const PaymentMethodRef = require('@/lib/PaymentMethods/PaymentMethodRef');
const PaymentToken = require('@/lib/Payments/PaymentToken');
const { hydrate } = require('@/lib/Hydration');

class GoCardlessService {
    /**
     * @param {ApiClient} apiClient
     * @param {PaymentMethodService} paymentMethodService
     */
    constructor(
        apiClient,
        paymentMethodService
    ) {
        this.apiClient = apiClient;
        this.paymentMethodService = paymentMethodService;

        /**
         * @private
         *
         * @type {PaymentMethod}
         */
        this.paymentMethod = null;
    }

    /**
     * @returns {PaymentMethod}
     */
    getPaymentMethod() {
        if (!this.paymentMethod) {
            this.paymentMethod = this.paymentMethodService.getByRef(PaymentMethodRef.GOCARDLESS);
        }

        return this.paymentMethod;
    }

    /**
     * Load a customer's existing DD mandates (payment tokens).
     *
     * @param {number} customerAccountID
     *
     * @returns {Promise<PaymentToken[]>}
     */
    async loadPaymentTokens(customerAccountID) {
        const paymentMethod = this.getPaymentMethod();

        return this.apiClient
            .request(
                'GET',
                `customeraccounts/${customerAccountID}/paymenttokens/active`,
            )
            .then(({ data }) => {
                return data
                    .map((token) => hydrate(token, new PaymentToken()))
                    .filter((paymentToken) => {
                        // Filter to only tokens for GC which are valid and active.
                        return paymentToken.paymentMethodID === paymentMethod.ID
                            && !!paymentToken.paymentMechanismReference
                            && !!paymentToken.authorisationReference
                            && paymentToken.reference
                            && paymentToken.reference !== 'INVALID';
                    });
            });
    }
}

module.exports = GoCardlessService;
